import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Divider
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function DynamicAccordionList({ data = [] }) {
  const [expanded, setExpanded] = useState("panel0");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 700, mx: "auto" }}>
      {data.map((section, index, arr) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
          disableGutters
          elevation={0}
          sx={{
            mt: index === 0 ? 0 : 1,
            mb: index === arr.length - 1 ? 0 : 1,
            border: '1px solid var(--gray-300)',
            borderTop: '1px solid var(--gray-300)',
            borderBottom: '1px solid var(--gray-300)',
            overflow: 'hidden',
           '&:first-of-type': {
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            },
            '&:last-of-type': {
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 15,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            },
            '&:not(:first-of-type):not(:last-of-type)': {
              borderRadius:3,
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <Typography variant="body1">{section.title}</Typography>
          </AccordionSummary>
          <Divider sx={{ width: "100%" }} />
          <AccordionDetails sx={{ px: 2 }}>
            {section.content}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}